<template>
  <v-row style="width: 95%" class="m-auto mb-4">
    <v-card-text class="mt-4">
      <v-data-table
        fixed-header
        :headers="Matchedheaders"
        :items="CompliancematchingList"
        :items-per-page="10"
        hide-default-footer
        dense
      >
        <template v-slot:item.compliance_name="{ item }">
          <p class="mb-0" :class="item.is_matched ? 'error--text' : ''">
            {{ item.compliance_name }}
          </p>
        </template>
        <template v-slot:item.compliance_status="{ item }">
          <v-chip
            small
            v-if="item.is_matched"
            dense
            flat
            depressed
            @click="OpenComplianceDialog(item)"
            :color="item.is_matched ? 'error' : 'success'"
          >
            <v-icon x-small class="me-2">mdi mdi-check-decagram</v-icon
            >{{ item.compliance_status }}
          </v-chip>
          <p
            class="mb-0 caption"
            v-else
            :class="item.is_matched ? 'error--text' : 'success--text'"
          >
            <v-icon
              :color="item.is_matched ? 'error' : 'success'"
              x-small
              class="me-2"
              >mdi mdi-check-decagram</v-icon
            >{{ item.compliance_status }}
          </p>
        </template>
      </v-data-table>
    </v-card-text>
    <v-dialog persistent v-model="showRulesDialog" width="1200">
      <v-card class="pa-0">
        <v-toolbar color="seconadry" dark flat dense>
          <span
            >Rules Matched List:
            <Strong>{{ rulesMatchedName }}</Strong></span
          >
          <v-spacer></v-spacer>
          <v-btn depressed icon @click="closeRulesList()">
            <v-icon>mdi-close-circle</v-icon>
          </v-btn>
        </v-toolbar>
        <rulesMatchedVue :matchedrulesdata="matcheddata" />
      </v-card>
    </v-dialog>
    <v-dialog persistent v-model="showSantionsDialog" width="1200">
      <v-card class="pa-0">
        <v-toolbar color="seconadry" dark flat dense>
          <span
            >Sanction Matched List:
            <Strong>{{ highlightWord.join(" ") }}</Strong></span
          >
          <v-spacer></v-spacer>
          <v-btn depressed icon @click="closeSantionList()">
            <v-icon>mdi-close-circle</v-icon>
          </v-btn>
        </v-toolbar>
        <sanctionMatchedVue
          :matchedsanctionsdata="matchedsanctionsdata"
          :highlightWord="highlightWord"
        />
      </v-card>
    </v-dialog>
    <v-dialog persistent v-model="showRiskDialog" width="1200">
      <v-card class="pa-0">
        <v-toolbar color="seconadry" dark flat dense>
          <span
            >Risk Profiling :<v-chip small class="ms-2" color="primary"
              >{{ RiskStatus ? RiskStatus : null }} :
              {{ transactionDetails.txn_data.risk_percentage }} %</v-chip
            ></span
          >
          <v-spacer></v-spacer>
          <v-btn depressed icon fab @click="closeRisk()">
            <v-icon>mdi-close-circle</v-icon>
          </v-btn>
        </v-toolbar>
        <RiskProfilingVue :RiskData="RiskData" />
      </v-card>
    </v-dialog>

    <OverlayPageVue :showOverlay="loader" />
  </v-row>
</template>

<script>
import OverlayPageVue from "@/utils/OverlayPage.vue";
import commonService from "@/services/CommonService/commonService.js";
import sanctionMatchedVue from "../../sanctionMatched.vue";
import rulesMatchedVue from "../../rulesMatched.vue";
import RiskProfilingVue from "../../../../../views/riskProfiling/RiskProfiling.vue";
export default {
  data() {
    return {
      Matchedheaders: [
        {
          text: "Category Name",
          value: "compliance_name",
          sortable: false,
        },
        { text: "Status", value: "compliance_status", sortable: false },
      ],
      headers: [
        {
          text: "SDN.no",
          value: "ofacKey",
          sortable: false,
        },
        { text: "Name", value: "name", sortable: false },
        { text: "Address", value: "address", sortable: false },
        { text: "Type", value: "vessel_type", sortable: false },
        { text: "Remarks", value: "remarks", sortable: false },
      ],
      isImageViewer: false,
      loader: false,
      imageViewerUrl: "",
      highlightWord: [],
      RiskData: [],
      matcheddata: [],
      RiskStatus: "",
      showSantionsDialog: false,
      showRiskDialog: false,
      showRulesDialog: false,
      matchedsanctionsdata: [],
    };
  },
  components: {
    OverlayPageVue,
    sanctionMatchedVue,
    rulesMatchedVue,
    RiskProfilingVue,
  },
  props: {
    CompliancematchingList: {
      type: Array,
    },
    transactionDetails: {
      type: Object,
    },
  },
  computed: {
    rulesMatchedName() {
      const sender =
        (this.transactionDetails && this.transactionDetails.sender_data) || {};
      return [sender.first_name, sender.middle_name, sender.last_name]
        .filter((name) => typeof name === "string")
        .map((name) => name.trim())
        .filter(Boolean)
        .join(" ");
    },
  },
  mounted() {},
  methods: {
    stoploader() {
      setTimeout(() => {
        this.loader = false;
      }, 400);
    },
    OpenComplianceDialog(item) {
      console.log("ttem", item);
      switch (item.compliance_category) {
        case "SANS":
          this.openMacthingData(item.matching_list, item.compliance_category);
          break;
        case "SANB":
          this.openMacthingData(item.matching_list, item.compliance_category);
          break;
        case "SANSE":
          this.openMacthingData(item.matching_list, item.compliance_category);
          break;
        case "RUL":
          this.openRulesData(item.matching_list);
          break;
        case "SANBE":
          this.openMacthingData(item.matching_list, item.compliance_category);
          break;
        case "RIS":
          this.OpenMatchingRisk(item);
      }
    },
    OpenMatchingRisk(item) {
      this.showRiskDialog = true;
      this.RiskStatus = item.compliance_status;
      this.RiskData = {
        percentage: this.transactionDetails.txn_data.risk_percentage,
        pin_no: this.transactionDetails.txn_data.pin_umber,
        list: this.transactionDetails.txn_data.risk_match,
      };
    },
    async openRulesData(item) {
      this.loader = true;
      const params = {
        txn_pin: this.transactionDetails.txn_data.pin_umber,
        rules_list: item,
      };
      try {
        const response = await commonService.getMatchedsRulesList(params);
        if (response.status === 200) {
          this.matcheddata = response.data.data;
          this.showRulesDialog = true;
          this.stoploader();
        } else {
          this.showAlertError(`Failed to fetch: ${response.data.message}`);
        }
        console.log("Matched Data", this.matcheddata);
      } catch (e) {
        console.error(e);
        this.stoploader();
        this.matcheddata = [];
      }
    },
    async openMacthingData(item, category) {
      this.loader = true;

      try {
        const response = await commonService.getMatchedsList(item);
        console.log("tes", response);
        console.log("this.transactionDetails", this.transactionDetails);
        if (response.status === 200) {
          this.matchedsanctionsdata = response.data.data;
          const person =
            (category === "SANB"
              ? this.transactionDetails.receiver_data
              : this.transactionDetails.sender_data) || {};
          this.highlightWord = [
            person.first_name,
            person.middle_name,
            person.last_name,
          ]
            .filter((name) => typeof name === "string")
            .map((name) => name.trim())
            .filter(Boolean);
          this.showSantionsDialog = true;
          this.stoploader();
        } else {
          this.showAlertError(`Failed to fetch: ${response.data.message}`);
        }
        console.log("Matched Data", this.matchedsanctionsdata);
      } catch (e) {
        console.error(e);
        this.stoploader();
        this.matchedsanctionsdata = [];
      }
    },

    closeSantionList() {
      this.showSantionsDialog = false;
    },
    closeRulesList() {
      this.showRulesDialog = false;
    },
    closeRisk() {
      this.showRiskDialog = false;
    },
  },
};
</script>

<style lang="scss" scoped>
th,
td {
  border: 1px solid rgb(231, 229, 229);
  border-collapse: collapse;
  padding: 3px;
  width: 200px;
}
</style>
